import React, { ReactNode } from 'react';
import { observer } from 'mobx-react-lite';
import { FiltersMap } from '@wix/bex-core';
import { CollectionCard } from '../CollectionCard';
import { TableFoldersState } from '../../state';

export interface TableFoldersLayoutProps<
  T1,
  F1 extends FiltersMap,
  T2,
  F2 extends FiltersMap,
> {
  dataHook?: string;
  children?: ReactNode | ReactNode[];
  state: TableFoldersState<T1, F1, T2, F2>;
}

function _TableFoldersLayout<
  T1,
  F1 extends FiltersMap,
  T2,
  F2 extends FiltersMap,
>(props: TableFoldersLayoutProps<T1, F1, T2, F2>) {
  const { state, dataHook, children } = props;

  const { toolbar } = state;

  return (
    <CollectionCard renderError={false} state={toolbar} dataHook={dataHook}>
      {children}
    </CollectionCard>
  );
}

export const TableFoldersLayout = observer(_TableFoldersLayout);
